import { ProjectStatus } from 'generated/graphql';
import {
  useCognitiveSkillsFromRoles,
  useSkillsFromProjectJobRoles,
} from 'hooks/useSkillsFromProjectJobRoles';
import { FC } from 'react';
import { Loader } from '@spotted-zebra-uk/ui-components';
import ProjectJobRolesOverviewPresentational from '../ProjectJobRolesOverviewPresentational/ProjectJobRolesOverviewPresentational';

interface IProjectJobRolesOverview {
  projectId: number;
  companyId: number;
  projectStatus: ProjectStatus;
  hasAssessmentStage: boolean;
}

const ProjectJobRolesOverview: FC<IProjectJobRolesOverview> = ({
  projectId,
  companyId,
  projectStatus,
  hasAssessmentStage,
}) => {
  const {
    projectJobRoles,
    softSkillsByCategory,
    productSolution,
    parsedTechnicalSkills,
    parsedSoftSkills,
    isLoading,
    projectJobRolesError,
    missingCategorySkillsInRoles,
  } = useSkillsFromProjectJobRoles({
    projectId,
  });

  const { cognitiveSkillsVersion } = useCognitiveSkillsFromRoles(
    softSkillsByCategory,
    productSolution,
  );
  if (projectJobRolesError) {
    // TODO: Add better error handling.
    return <div>{projectJobRolesError.message}</div>;
  }

  if (isLoading) {
    return (
      <div data-testid="project-job-roles-overview-loader">
        <Loader variant="bubbles" />
      </div>
    );
  }

  if (projectJobRoles) {
    return (
      <ProjectJobRolesOverviewPresentational
        projectId={projectId}
        companyId={companyId}
        technicalSkills={parsedTechnicalSkills}
        softSkills={softSkillsByCategory}
        projectJobRoles={projectJobRoles}
        hasSkills={
          parsedSoftSkills.length > 0 || parsedTechnicalSkills.length > 0
        }
        cognitiveSkillsVersion={cognitiveSkillsVersion}
        missingCategorySkillsInRoles={missingCategorySkillsInRoles}
        projectStatus={projectStatus}
        hasAssessmentStage={hasAssessmentStage}
      />
    );
  }

  return (
    <div data-testid="project-job-roles-overview-loader">
      <Loader variant="bubbles" />
    </div>
  );
};

export default ProjectJobRolesOverview;
